// extracted by mini-css-extract-plugin
module.exports = {"countdown":"CountDown_countdown__YgxBi","timer":"CountDown_timer__H6tNI","opacity":"CountDown_opacity__foaE9"};